import http from "@/utils/request"

export default {
	withdraw: {
		list: async function (data = {}) {
			return await http.get("wallet/withdraw/list", data);
		},
	},
	wallet: {
		option: async function (data = {}) {
			return await http.get("wallet/option", data);
		},
		my: async function (data = {}) {
			return await http.get("wallet/my", data);
		},
	},
}
